import { useRef, useState } from 'react'
import cn from 'classnames'
import { IconPlus, IconMinus } from './tree.icons'
import { TreeChildProps } from './tree.interface'

export const TreeItem = ({ items  }: TreeChildProps) => {
  const [isActive, setActive] = useState(false)
  const refSubItem = useRef<HTMLSpanElement>(null)

  const onToggle = () => {
    setActive((prev) => !prev)
  }

  const classSubItem = cn ({
    'legion-tree__sub-item': true,
    'legion-tree__sub-item--show': isActive
  })

  if (items.childrens) {
    return (
      <>
        <span className='legion-tree__item'>
          <button className='legion-tree__icon' onClick={onToggle}>
            {isActive ? <IconMinus /> : <IconPlus />}
          </button>
          {items.title}
        </span>
        
        {/* childrens  */}
        <span className={classSubItem} style={{ height: isActive ? refSubItem.current?.offsetHeight || 0 : 0 }}>
          <span className="legion-tree__children" ref={refSubItem}>
            {items.childrens.map((child, index) => (
              <TreeItem key={index} items={child} />
            ))}
          </span>
        </span>
      </>
    )
  } else {
    return <span className='legion-tree__item'>{items.title}</span>
  }
}
